import { render, staticRenderFns } from "./pages.vue?vue&type=template&id=bd48e6c0&scoped=true&"
import script from "./pages.vue?vue&type=script&lang=js&"
export * from "./pages.vue?vue&type=script&lang=js&"
import style0 from "./pages.vue?vue&type=style&index=0&id=bd48e6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd48e6c0",
  null
  
)

export default component.exports